module.exports = __webpack_public_path__ + "static/media/anc6ru.67280076.pdf";